import {SummaryModel} from '../../../../common/entity/summary.model';
import {PermissionsModel} from '../../../../common/entity/permissions.model';

export class DocumentTemplateSummaryModel implements SummaryModel {
    id: number;
    permissions: PermissionsModel;
    name: string;
    enableExternalSignature: boolean;
}
